import { render, staticRenderFns } from "./ThePart4Main.vue?vue&type=template&id=509384f4&scoped=true"
import script from "./ThePart4Main.vue?vue&type=script&lang=js"
export * from "./ThePart4Main.vue?vue&type=script&lang=js"
import style0 from "./ThePart4Main.vue?vue&type=style&index=0&id=509384f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509384f4",
  null
  
)

export default component.exports